<template>
    <b-form-input
        ref="duration"
        :key="key"
        v-model="form.activity_duration"
        size="sm"
        placeholder="0.0"
        :class="reactiveClass"
        @change="saveDuration"
    >
    </b-form-input>
</template>

<script>
import TableFormHandler from '../../../common/mixins/TableFormHandler.vue'

export default {
    name: 'DurationForm',

    mixins: [TableFormHandler],

    props: {
        entry: {},
    },

    methods: {
        initForm() {
            this.form.activity_duration =
                this.entry.activity_duration.toFixed(2)
        },

        setInitialKey() {
            this.key = `duration${this.entry.id}`
        },

        unFocus() {
            this.$refs.duration.blur()
        },

        async saveDuration() {
            try {
                await axios.put(
                    `/time-sheets/${this.entry.id}/duration`,
                    this.form
                )
                this.handleSuccess()
                this.$emit('updated')
                // this.$root.$refs.timeSheetsInput.getData()
            } catch (error) {
                console.log(error)
                this.handleError()
                if (error.response) {
                    if (error.response.status === 403) {
                        this.$store.commit(
                            'timeSheetsVM/SET_ERROR',
                            error.response.data.meta.message
                        )
                    }
                }
            }
        },
    },
}
</script>

<style scoped></style>
